var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "text-nowrap" }, [
    _vm._v("\n    " + _vm._s(_vm.text) + "\n    "),
    _vm.ordering !== _vm.ascParam && _vm.ordering !== _vm.descParam
      ? _c(
          "a",
          {
            attrs: {
              href: _vm.generateUrl("order", _vm.ascParam),
              title: "Sort in ascending order",
            },
          },
          [
            _c("i", {
              staticClass: "fa fa-sort",
              attrs: { "aria-hidden": "true" },
            }),
          ]
        )
      : _vm.ordering === _vm.descParam
      ? _c(
          "a",
          {
            attrs: {
              href: _vm.generateUrl("order", _vm.ascParam),
              title: "Sort in ascending order",
            },
          },
          [
            _c("i", {
              staticClass: "fa fa-sort-asc",
              attrs: { "aria-hidden": "true" },
            }),
          ]
        )
      : _vm.ordering === _vm.ascParam
      ? _c(
          "a",
          {
            attrs: {
              href: _vm.generateUrl("order", _vm.descParam),
              title: "Sort in descending order",
            },
          },
          [
            _c("i", {
              staticClass: "fa fa-sort-desc",
              attrs: { "aria-hidden": "true" },
            }),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }